{
  "version": 1,
  "paths": [
    "kaykit/halloween/grave_A.gltf",
    "kaykit/halloween/grave_A_destroyed.gltf",
    "kaykit/halloween/grave_B.gltf",
    "kaykit/halloween/gravemarker_A.gltf",
    "kaykit/halloween/gravemarker_B.gltf",
    "kaykit/halloween/gravestone.gltf",
    "kaykit/halloween/bone_A.gltf",
    "kaykit/halloween/bone_B.gltf",
    "kaykit/halloween/bone_C.gltf",
    "kaykit/halloween/ribcage.gltf",
    "kaykit/halloween/skull.gltf",
    "kaykit/halloween/skull_candle.gltf",
    "kaykit/halloween/tree_dead_large.gltf",
    "kaykit/halloween/tree_dead_medium.gltf",
    "kaykit/halloween/tree_dead_small.gltf",
    "kaykit/halloween/tree_pine_orange_medium.gltf",
    "kaykit/halloween/tree_pine_yellow_medium.gltf",
    "kaykit/halloween/fence_broken.gltf",
    "kaykit/halloween/fence_pillar_broken.gltf",
    "kaykit/halloween/post_skull.gltf",
    "kaykit/halloween/lantern_standing.gltf",
    "kaykit/halloween/pumpkin_orange.gltf",
    "kaykit/halloween/pumpkin_orange_jackolantern.gltf",
    "kaykit/halloween/crypt.gltf",
    "kaykit/halloween/shrine_candles.gltf",
    "kaykit/halloween/pillar.gltf",
    "kaykit/halloween/arch.gltf",
    "kaykit/dungeon/rubble_half.glb",
    "kaykit/dungeon/rubble_large.glb",
    "kaykit/dungeon/barrel_large.glb",
    "kaykit/dungeon/crates_stacked.glb",
    "kaykit/dungeon/sword_shield_broken.glb",
    "kaykit/dungeon/column.glb",
    "kaykit/dungeon/wall_broken.glb",
    "kaykit/dungeon/torch_lit.glb",
    "kaykit/dungeon/chest_gold.glb",
    "kaykit/hexagon/tree_single_A.gltf",
    "kaykit/hexagon/tree_single_B.gltf",
    "kaykit/hexagon/trees_A_medium.gltf",
    "kaykit/halloween/tree_pine_orange_large.gltf",
    "kaykit/hexagon/rock_single_A.gltf",
    "kaykit/hexagon/rock_single_B.gltf",
    "kaykit/hexagon/rock_single_C.gltf",
    "kaykit/hexagon/rock_single_D.gltf",
    "kaykit/hexagon/resource_lumber.gltf",
    "kaykit/hexagon/tent.gltf",
    "kaykit/hexagon/weaponrack.gltf",
    "kaykit/hexagon/target.gltf",
    "kaykit/hexagon/barrel.gltf",
    "kaykit/hexagon/crate_A_big.gltf",
    "kaykit/hexagon/sack.gltf",
    "kaykit/hexagon/bucket_arrows.gltf",
    "kaykit/hexagon/flag_red.gltf",
    "kaykit/hexagon/building_well_blue.gltf",
    "kaykit/hexagon/trees_A_large.gltf",
    "kaykit/adventurers/characters/Knight.glb",
    "kaykit/adventurers/characters/Barbarian.glb",
    "kaykit/adventurers/characters/Mage.glb",
    "kaykit/adventurers/characters/Rogue.glb",
    "kaykit/skeletons/characters/Skeleton_Minion.glb",
    "kaykit/skeletons/characters/Skeleton_Rogue.glb",
    "kaykit/skeletons/characters/Skeleton_Mage.glb",
    "kaykit/skeletons/characters/Skeleton_Warrior.glb"
  ]
}
